module.exports = __webpack_public_path__ + "img/newCheck.cdd0ea6b.svg";